import { useEffect, useRef, useState } from "react";

export default function QuantityDropdown({ value, max, label, onChange, fixed = false }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener("pointerdown", outside);
    root.current?.querySelector(`[data-quantity="${value}"]`)?.focus();
    return () => document.removeEventListener("pointerdown", outside);
  }, [open, value]);
  const choices = fixed ? [value] : Array.from({ length: max }, (_, index) => index + 1);
  if (fixed) return <div className="cartQuantityReadout" aria-label={`${label}: ${value}`}>{value}</div>;
  const close = () => { setOpen(false); trigger.current?.focus(); };
  return <div className="modernQuantity" ref={root} onKeyDown={event => {
    if (event.key === "Escape") { event.preventDefault(); close(); }
    if (open && ["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
      event.preventDefault();
      const options = [...root.current.querySelectorAll('[role="option"]')];
      const index = options.indexOf(document.activeElement);
      const next = event.key === "Home" ? 0 : event.key === "End" ? options.length - 1 : (index + (event.key === "ArrowDown" ? 1 : -1) + options.length) % options.length;
      options[next]?.focus();
    }
  }}>
    <button ref={trigger} type="button" className="modernQuantityTrigger" aria-label={label} aria-haspopup="listbox" aria-expanded={open}
      onClick={() => setOpen(!open)} onKeyDown={event => { if (event.key === "ArrowDown") { event.preventDefault(); setOpen(true); } }}>
      {value}<span aria-hidden="true">⌄</span>
    </button>
    {open && <div className="modernQuantityMenu" role="listbox" aria-label={label}>
      {choices.map(quantity => <button type="button" role="option" aria-selected={quantity === value} data-quantity={quantity} key={quantity}
        onClick={() => { onChange(quantity); close(); }}>{quantity}<span aria-hidden="true">{quantity === value ? "✓" : ""}</span></button>)}
    </div>}
  </div>;
}
